import { useToastCookieErrors } from "./use-toast-cookie-errors";
import { useToastQueryErrors } from "./use-toast-query-errors";

export { useToastQueryErrors, useToastCookieErrors };
